import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * [検索用]パッケージ・商品一覧API(認証ありページ用)
 * @param  {} params={}
 */
export const listPackagesAndProductsForSearch = (params = {}) => {
  const defaults = {
    _path: 'QA/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * [任意選択用]パッケージ・商品一覧API(認証ありページ用)
 * @param  {} params={}
 */
export const listPackagesAndProductsForAll = (params = {}) => {
  params.all = true
  return listPackagesAndProductsForSearch(params)
}


/**
 * [選択用]パッケージ・商品一覧API(認証なしページ用)
 * @param  {} params={}
 */
export const listPackagesAndProductsForNonAuthForAll = (params = {}) => {
  const defaults = {
    _path: 'QA/017',
    token: store.state.auth.token
  }

  params.all = true

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * [検索用]書籍一覧API
 * @param  {} params={}
 */
export const listBooksForSearch = (params = {}) => {
  const defaults = {
    _path: 'QA/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * [選択用]書籍一覧API
 * @param  {} params={}
 */
export const listBooksForAll = (params = {}) => {
  params.all = true
  return listBooksForSearch(params)
}

/**
 * 書籍目次書式DL一覧API
 * @param  {} params={}
 */
export const listBooksAndFormDownloads = (params = {}) => {
  const defaults = {
    _path: 'QA/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 書籍目次一覧API
 * @param  {} params={}
 */
export const listBookTableOfContents = (params = {}) => {
  const defaults = {
    _path: 'QA/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * QA一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const defaults = {
    _path: 'QA/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * リビジョン一覧API（リビジョン切替用）
 * @param  {} params={}
 */
export const listRevisionsForChange = (params = {}) => {
  const defaults = {
    _path: 'QA/008',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * リビジョン一覧API（リビジョン選択用）
 * @param  {} params={}
 */
export const listRevisionsForChoice = (params = {}) => {
  const defaults = {
    _path: 'QA/018',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 書籍情報取得API
 * @param  {} params={}
 */
export const fetchBookInfo = (params = {}) => {
  const defaults = {
    _path: 'QA/009',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * QA詳細取得API
 * @param  {} params={}
 */
export const detail = (params = {}) => {
  const defaults = {
    _path: 'QA/010',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 関連情報一覧API
 * @param  {} params={}
 */
export const listBookExampleRelatedInfo = (params = {}) => {
  const defaults = {
    _path: 'QA/011',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 関連情報・内容現在ページ取得API（WLJP連携）
 * @param  {} params={}
 */
export const fetchBookExampleRelatedPage = (params = {}) => {
  const defaults = {
    _path: 'QA/012',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 内容現在一覧API
 * @param  {} params={}
 */
export const listBookExampleRelatedContents = (params = {}) => {
  const defaults = {
    _path: 'QA/013',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 書式DL一覧API
 * @param  {} params={}
 */
export const listFormDownloads = (params = {}) => {
  const defaults = {
    _path: 'QA/014',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * キーワード検索結果件数取得API
 * @param  {} params={}
 */
export const countKeywordSearchResults = (params = {}) => {
  const defaults = {
    _path: 'QA/015',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 裁判所一覧取得API
 * @param  {} params={}
 */
export const listCourts = (params = {}) => {
  const defaults = {
    _path: 'QA/016',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
